import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Loader2, Lock, Mail } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) return <div className="min-h-screen flex items-center justify-center bg-white text-[#0C2749]">Laden …</div>;
  if (user) return <Navigate to="/admin/dashboard" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0C2749] text-white flex items-center justify-center p-6 blueprint-bg-strong">
      <form onSubmit={onSubmit} className="bg-white text-[#0C2749] w-full max-w-md p-8 md:p-10 rounded-sm shadow-2xl" data-testid="admin-login-form">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#2873B8] mb-3">Admin</p>
        <h1 className="text-3xl font-bold mb-6" style={{ fontFamily: "Outfit" }}>Anmeldung</h1>
        <div className="space-y-4">
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@easyrohbau.de"
              className="w-full pl-10 pr-3 py-3 border border-slate-200 focus:border-[#2873B8] focus:outline-none rounded-sm bg-white"
              data-testid="admin-email"
            />
          </div>
          <div className="relative">
            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Passwort"
              className="w-full pl-10 pr-3 py-3 border border-slate-200 focus:border-[#2873B8] focus:outline-none rounded-sm bg-white"
              data-testid="admin-password"
            />
          </div>
        </div>
        <button
          type="submit"
          disabled={submitting}
          className="btn-shimmer mt-6 w-full inline-flex items-center justify-center gap-2 bg-[#0C2749] hover:bg-[#2873B8] text-white px-6 py-3 rounded-sm font-medium transition-colors disabled:opacity-60"
          data-testid="admin-submit"
        >
          {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
          Anmelden
        </button>
      </form>
    </div>
  );
}
